
<nz-modal
  [nzVisible]="!!edit.obj"
  [nzTitle]="'web.common.user.deleteUser' | actrans | str"

  (nzOnCancel)="onCancel()"
  (nzOnOk)="onOk()"
  [nzOkLoading]="edit.loading"
  [nzOkDanger]="true"
  [nzOkText]="'web.common.user.deleteUser' | actrans | str"
  >
  <ng-container *nzModalContent>

    @if (edit.obj) {
      <div>
        <form nz-form nzLayout="vertical" [nzAutoTips]="bas.fs.autoTips">
          <btlib-form-row  [controls]="[ edit.controls.confirmDelete ]" [form]="edit.form"  [grid]="bas.ui.gridFull" (change)="onChange($event)" ></btlib-form-row>
          @if (bas.aas.isAdmin()) {
            <div>
              <btlib-form-row  [controls]="[ edit.controls.force ]" [form]="edit.form"  [grid]="bas.ui.gridFull" (change)="onChange($event)" ></btlib-form-row>
            </div>
          }
        </form>
      </div>
    }

  </ng-container>

</nz-modal>

